import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { noteStrings } from '../../lib/noteHelper';
import './Piano.css';

const COLORS = {
  EBONY: 'ebony',
  IVORY: 'ivory'
};
const SHIFTS = {
  LEFT: -7,
  MIDDLE: -5,
  RIGHT: -3
};

function getKeyDeets(keyPos) {
  const key = keyPos % 12;
  let shift;
  let color;
  let height = 125;
  let width = 22;
  let offset = 22;

  if (key === 2 || key === 7) {
    shift = SHIFTS.RIGHT;
    color = COLORS.EBONY;
    height -= 45;
    width = 11;
  } else if (key === 5 || key === 10) {
    shift = SHIFTS.LEFT;
    color = COLORS.EBONY;
    height -= 45;
    width = 11;
  } else if (key === 0) {
    shift = SHIFTS.MIDDLE;
    color = COLORS.EBONY;
    height -= 45;
    width = 11;
  } else {
    shift = null;
    color = COLORS.IVORY;
  }
  return { pos: keyPos, shift, color, width, height, offset };
}

class Piano extends Component {
  static propTypes = {
    currentNote: PropTypes.object,
    debug: PropTypes.bool
  };

  constructor(props) {
    super(props);
    // da A3 ad A5
    this.notes = [...Array(27).keys()].map(i => i + 35);
  }

  componentDidMount() {
    this.img = React.createRef();
  }

  drawKeys = (notes, selected) => {
    let left = 0;
    const blackKeyGroup = [];
    const whiteKeyGroup = [];
    notes.forEach((note, idx) => {
      const noteX = left;
      const noteElement = (
        <rect
          key={idx}
          rx={2}
          x={noteX + note.shift}
          y={14}
          width={note.width}
          height={note.height}
          fill={selected === note.pos ? '#EC6075' : note.color}
          stroke={'#000000'}
        />
      );
      if (note.color === COLORS.IVORY) {
        left += 22;
        whiteKeyGroup.push(noteElement);
        if (this.props.debug) {
          const keyText = (
            <text key={'text' + idx} x={noteX + note.width / 2} y={10} textAnchor="middle">
              {note.pos}
            </text>
          );
          whiteKeyGroup.push(keyText);
        }
      } else {
        blackKeyGroup.push(noteElement);
      }
    });
    return [React.createElement('g', { key: 0 }, whiteKeyGroup), React.createElement('g', { key: 1 }, blackKeyGroup)];
  };

  renderDebug = (note, selectedNote) => {
    const isNoteInRange = this.notes.includes(selectedNote);
    return (
      <div>
        {!isNoteInRange && <div>NOTA NON DISPONIBILE </div>}
        {note && (
          <div>
            {note.toString()} - {note.pitch + note.accidentalString()}
          </div>
        )}
        <div>NoteNumber: {selectedNote}</div>
        <div />
      </div>
    );
  };

  render() {
    let notes = this.notes.map(x => getKeyDeets(x));
    const whiteKeys = notes.filter(x => x.color === COLORS.IVORY).length;
    const svgWidth = 22 * whiteKeys;
    const svgHeight = 150;

    const { currentNote } = this.props;

    let selectedNote = null;
    if (currentNote) {
      const currentNoteString = currentNote.pitch + currentNote.accidentalString();
      selectedNote = 28 + noteStrings.indexOf(currentNoteString.toUpperCase()) + 12 * (currentNote.octave - 3);
    }

    return (
      <div style={{ textAlign: 'center' }}>
        {this.props.debug && this.renderDebug(currentNote, selectedNote)}
        <div>
          <svg className="piano" viewBox={[0, 0, svgWidth, svgHeight].join(' ')}>
            {notes && this.drawKeys(notes, selectedNote)}
          </svg>
        </div>
      </div>
    );
  }
}

export default Piano;
